<template>
  <v-container fill-height fluid>
    <v-row justify="center" align="center">
      <v-col>
        <v-row>
          <v-col cols="12" sm="4" offset-sm="4">
            <div class="text-center mb-4">
              <img src="img/logo.png" style="max-width: 250px; " />
              <div>ล็อคอินเพื่อเข้าสู่ระบบ</div>
            </div>

            <ValidationObserver ref="observer" tag="form">
              <ValidationProvider
                name="Username"
                :rules="{
                  required: true,
                }"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  background-color="white"
                  type="text"
                  placeholder="ชื่อผู้ใช้"
                  v-model="username"
                  autocomplete="username"
                ></v-text-field>
              </ValidationProvider>

              <ValidationProvider
                name="Password"
                :rules="{
                  required: true,
                }"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  background-color="white"
                  type="password"
                  placeholder="รหัสผ่าน"
                  v-model="password"
                  autocomplete="current-password"
                  @keyup.enter="$refs.loginbtn.$el.click()"
                ></v-text-field>
              </ValidationProvider>

              <div class="text-center mt-4">
                <vue-recaptcha
                  ref="recaptcha"
                  @verify="login"
                  @expired="onExpired"
                  sitekey="6Lc60GQUAAAAAMhf0gyvGKZMiDeOTbns-UbJpTcc"
                >
                  <v-btn ref="loginbtn" color="primary" :loading="loading">เข้าสู่ระบบ</v-btn>
                </vue-recaptcha>
              </div>
            </ValidationObserver>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";
export default {
  data() {
    return {
      username: null,
      password: null,
      loading: false,
      recaptcha: undefined,
    };
  },
  components: {
    VueRecaptcha,
  },
  methods: {
    async login(token) {
      var isValid = await this.$refs.observer.validate();

      if (!isValid) {
        this.resetRecaptcha();
        return false;
      }
      this.$refs.recaptcha.execute();
      this.loading = true;
      try {
        var response = await axios.post(
          `${this.$store.state.serverUrl}chillpainai_influencer_login`,
          { userid: this.username, password: this.password, "g-recaptcha-response": token },
          {
            params: { pageid: this.$store.state.pageid },
            headers: {
              AUTHORIZATION: "BEARER xxx xxx",
            },
          }
        );
        if (
          response.status == 200 &&
          response.data.responsecode == 200 &&
          response.data.data &&
          response.data.data.length > 0
        ) {
          //
          var user = response.data.data[0];
          if (user.password) {
            delete user.password;
          }
          if (user.productidlist) {
            user.productidlist = user.productidlist.split(",");
          }
          try {
            if (user.jsonvalue) {
              user.jsonvalue = JSON.parse(user.jsonvalue);
            } else {
              user.jsonvalue = [];
            }
          } catch (error) {
            //
            user.jsonvalue = [];
          }
          this.$store.commit("LOGIN", user);
          this.$router.push({
            name: "Summary",
          });
        } else if (response.status == 200 && response.data.responsecode == 400) {
          await this.$swal.fire({
            icon: "error",
            title: response.data.reason,
          });
        }
      } catch (error) {
        await this.$swal.fire({
          icon: "error",
          title: error.message,
        });
      }

      this.resetRecaptcha();

      this.loading = false;
    },
    onExpired() {
      this.resetRecaptcha(); // Direct call reset method
    },
    resetRecaptcha() {
      this.$refs.recaptcha.reset(); // Direct call reset method
    },
  },
};
</script>

<style lang="scss" scoped></style>
